import React from 'react';
import CopyableField from '../../library/CopyableField';
import { Pill } from '../../library/Pill';
import ProfilePhoto from './ProfilePhoto';
import {
    InfoItem,
    InfoItemContent,
    InfoList,
    NameBlock,
    StudentIdentity,
    StudentIdentityLayout,
    StudentName,
} from './ProfilePictureUpload.styles';

/**
 * Student identity block shared by the profile pages: avatar, name, an
 * optional status pill, and the student number/email with copy shortcuts.
 * @param {Object} user Logged-in student from the redux store
 * @param {boolean} showStatus Whether to show the student status pill
 */
function StudentIdentityCard({ user, showStatus = false }) {
    return (
        <StudentIdentityLayout>
            <StudentIdentity>
                <ProfilePhoto photoUrl={user?.photo} />
                <NameBlock>
                    <StudentName>
                        {user?.first_name} {user?.last_name}
                    </StudentName>
                    {showStatus ? (
                        <Pill $variant={user?.status === 'Active' ? 'success' : 'alert'}>
                            {user?.status ? user?.status : 'NA'}
                        </Pill>
                    ) : null}
                </NameBlock>
            </StudentIdentity>

            <InfoList>
                <InfoItem>
                    <CopyableField
                        textToCopy={user?.student_crm_id}
                        copyTitle="Copy student number"
                        copyButtonOffset="0"
                    >
                        <InfoItemContent>
                            <i className="fal fa-user"></i>
                            <span>{user?.student_crm_id}</span>
                        </InfoItemContent>
                    </CopyableField>
                </InfoItem>
                <InfoItem>
                    <CopyableField textToCopy={user?.email} copyTitle="Copy email" copyButtonOffset="0">
                        <InfoItemContent>
                            <i className="fal fa-envelope"></i>
                            <span>{user?.email}</span>
                        </InfoItemContent>
                    </CopyableField>
                </InfoItem>
            </InfoList>
        </StudentIdentityLayout>
    );
}

export default StudentIdentityCard;
